import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-cart",
  "use": "icon-cart-usage",
  "viewBox": "0 0 16 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 21\" id=\"icon-cart\"><g fill=\"param(fill) none\" stroke=\"param(outline) #000\" fill-rule=\"evenodd\"><path d=\"M12.826 5.86h2.615v11.715c0 1.451-1.226 2.627-2.738 2.627H3.238C1.726 20.202.5 19.026.5 17.575V5.86h2.615M5.355 5.86h5.229M4.235 9.804V6.219M4.235 6.218V4.425M11.705 6.218V4.425M11.705 9.804V6.219M4.235 4.425C4.235 2.445 5.907.84 7.97.84c2.063 0 3.735 1.605 3.735 3.585\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol